import { logEvent } from './logGaEvent'

/**
 * Builds item_list array for `ecommerce.items`
 * @param {Array} listings
 * @param {Object} searchLoadEventData - Concatenated Object of static and dynamic events attributes
 * @returns
 */
const getItemList = (listings, searchLoadEventData) => {
  const {
    trip_end_city_name: tripEndCityName,
    ap,
    los,
    type,
  } = searchLoadEventData

  // 1-pass to filter out ads (sponsored, crossSell, etc.)
  return listings?.reduce((arr, itin) => {
    const { airlines, slices } = itin

    if (slices) {
      const stops = slices?.[0]?.stops
      const connections =
        stops < 1
          ? 'direct'
          : stops === 1
          ? '1'
          : 'multiple' /*direct, 1, multiple*/

      arr.push({
        item_name: 'air_' + tripEndCityName,
        item_category: 'air',
        item_category_2: tripEndCityName /*dest_city_name*/,
        item_category_3: `${ap}` + '_' + `${los}` /*grouped ap + grouped los*/,
        item_id: airlines?.[0]?.marketingAirline /*carrier code*/,
        item_brand: airlines?.[0]?.name /*carrier name*/,
        cabin_class: itin?.allFareBrandNames?.[0] /*cabin class*/,
        connections: connections,
        slice: type /*2,3, etc   - Since NO MD now, slices will consistently remain 1 or 2*/,
        index:
          itin?.listingPosition /*this is the position of the listings card on the page*/,
        price: itin?.totalPriceWithDecimal?.price,
      })
    }
    return arr
  }, [])
}

/**
 * Builds reusable static data for "view_item_list"
 * @param {props, state}
 * @returns {Object}
 */
const getStaticItemEventsData = ({
  hasExpressDeal,
  tripType,
  cabinClass,
  travelDate,
  departingFrom,
  returningFrom,
  airportsArray,
  searchRequestParams,
  ap,
  los,
}) => ({
  search_name: hasExpressDeal ? 'express' : 'retail',
  itinerary_type: tripType,
  inventory_available: 'Y',
  cabin_class: cabinClass,
  trip_start_month: travelDate.split('-')[1],
  trip_start_airport: departingFrom?.airportCode,
  trip_start_city_id: departingFrom?.cityCode, // city code (NYC)
  trip_start_city: departingFrom?.cityName,
  trip_start_state: airportsArray[0]?.stateCode,
  trip_start_country: airportsArray[0]?.countryCode,
  trip_end_airport: returningFrom?.airportCode,
  trip_end_city: returningFrom?.cityCode,
  trip_end_city_name: returningFrom?.cityName,
  trip_end_state: airportsArray[airportsArray.length - 1]?.stateCode,
  trip_end_country: airportsArray[airportsArray.length - 1]?.countryCode,
  num_adults: searchRequestParams['num-adults'],
  num_youths: searchRequestParams['num-youths'],
  num_infants: searchRequestParams['num-infants'] || 0,
  num_children: searchRequestParams['num-children'],
  ap: ap,
  los: los,
  bundle_flag: 'N',
  bundle_type: null,
  page_name: 'listings',
})

/**
 * Generates dynamic 'type' and 'filters_applied' tagging data on slice change for RT
 * @param {Number} activeTabId
 * @param {Array} filterHistory
 * @returns Object
 */
const getDynamicItemEventsData = (activeTabId, filterHistory) => ({
  type: 'slice_' + activeTabId,
  filters_applied:
    filterHistory?.allFilters?.length === 0
      ? 'N'
      : 'Y' /*are any filters applied*/,
})

/** Logs the "view_item_list" ga tagging event
 * @param {Array} listings
 * @param {Object} searchLoadEventData
 */

const logItemList = (itemList, searchLoadEventData) => {
  if (itemList) {
    const attributes = {
      ...searchLoadEventData,
      ecommerce: {
        items: itemList,
      },
    }

    logEvent('view_item_list', attributes)
  }
}

const logViewItemListFlexDates = items => {
  if (items?.length > 0) {
    logEvent('view_item_list', {
      itinerary_type: 'ow',
      page_name: 'listings',
      product_name: 'air',
      ecommerce: {
        items,
      },
    })
  }
}

export {
  getItemList,
  logItemList,
  getStaticItemEventsData,
  getDynamicItemEventsData,
  logViewItemListFlexDates,
}
